import validate from 'validate.js'

const constraints = {
  recurrentAvailability: {
    presence: true,
  },
  educatorId: {
    presence: true,
  },
}

export default (data) => {
  return validate(data, constraints)
}
